import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { addDays } from 'date-fns';
import { dropTask } from 'ember-concurrency';
import { localCopy } from 'tracked-toolbox';
import { alias, equal } from 'macro-decorators';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

export default class TrialExtensionModal extends Component {
  @service state;
  @service flashMessages;

  @alias('state.desksSubscription') subscription;

  @localCopy('args.trialExtensionDays', 14) trialExtensionDays;

  @equal('subscription.timesTrialExtended', 0) canExtendTrial;

  @dropTask
  *extendTrialTask() {
    if (!this.canExtendTrial) return;

    if (this.subscription.onExpiredTrial) {
      this.subscription.trialEndDate = addDays(new Date(), this.trialExtensionDays);
    } else {
      this.subscription.trialEndDate = addDays(this.subscription.trialEndDate, this.trialExtensionDays);
    }

    try {
      yield this.subscription.save();
    } catch (e) {
      const errorText = parseErrorForDisplay(e);
      this.flashMessages.showAndHideFlash('error', errorText);
      this.subscription.rollbackAttributes();
    }

    if (typeof this.args.onClose === 'function') {
      this.args.onClose();
    }
  }
}
